

















































import { Component, Prop, Vue } from 'vue-property-decorator';
import Article from '../../logic/model/Article';
import PriceItem from '../../logic/model/PriceItem';
import PizzaIcon from './PizzaIcon.vue';

@Component({
    components: {
        PizzaIcon
    }
})
export default class ArticleItem extends Vue{
    @Prop()
    article!:Article 

    private priceItem:PriceItem|null = null;
    
    getSizes(article:Article) {
        let sizes = [];
        for (const size of article.$prices) {
            sizes.push(size.$name);
        } 
        return sizes;
    }

    private get priceSelectItems() {
        let items:any = [];
        this.article.$prices.forEach(priceItem => {
            items.push({text: priceItem.$name, value: priceItem})
        })
        return items;
    }

    private get icon() {
        if (this.article.$description) {
            let loweredIngredients = this.article.$description.toLowerCase();
            if (loweredIngredients.includes('salami')) {
                return 'salami-svgrepo-com'
            } else if (loweredIngredients.includes('ananas')) {
                return 'pineapple'
            } else if (loweredIngredients.includes('schinken')) {
                return 'ham'
            } else if (loweredIngredients.includes('thunfisch')) {
                return 'tuna'
                
            } else if (loweredIngredients.includes('hähnchenfleisch')) {
                return 'spaguetti'
            } else if (loweredIngredients.includes('käse')) {
                return 'cheese'
            } else {
                return 'pizza'
            }
        } else {
            return 'pizza'
        }
        
    }

    private renderPrice() {
        let price = this.priceItem ? this.priceItem.$price : 0;
        return  price.toFixed(2) + "€"
    }

   

    mounted() {
        let defaultSize = this.article.$prices.find( (item:PriceItem) => {
            return item.$name === "L"
        });
        if (defaultSize) {
            this.priceItem = defaultSize
        } else {
            this.priceItem = this.article.$prices[0];
        }

    }
}
